import { connect } from 'react-redux';

import {
  getMetainf,
  getProjectZoneId,
  getDashboardsRevenuePaymentFilter,
} from '../../../../../reducers/analyticsApp';
import {
  addFilterClause,
  removeFilterClause,
  removeFilter,
  setClausesConcatOperator,
  setFilterClauseOperator,
  setFilterClauseField,
  setFilterClauseValue,
  setFilterVisibility,
} from '../../../../../actions/dashboards/revenue';
import { commonEvents } from '../../../../../constants/event';
import EventFilterContainer from '../../../../../components/filter/EventFilterContainer';
import { isNotEmptyClause } from '../../../../../utils/filter';

const mapStateToProps = (state, { unit }) => {
  const filter = getDashboardsRevenuePaymentFilter(state, unit.id);
  return {
    metainf: getMetainf(state, commonEvents.PAYMENT),
    zoneId: getProjectZoneId(state),
    concatOperator: filter.concatOperator,
    clauses: filter.clauses,
    visibility: filter.visibility,
    badgeCount: filter.clauses.filter(isNotEmptyClause).length,
    btnText: 'Payment filter',
  };
};

const mapDispatchToProps = (dispatch, { unit }) => ({
  onSetClausesConcatOperator: (value) => dispatch(setClausesConcatOperator(unit.id, value)),
  onAddFilterClause: () => dispatch(addFilterClause(unit.id)),
  onRemoveFilterClause: (id) => dispatch(removeFilterClause(unit.id, id)),
  onSelectFilterClauseField: (id, field, type) =>
    dispatch(setFilterClauseField(unit.id, id, field, type)),
  onSelectFilterClauseOperator: (id, value, resetClauseValue) =>
    dispatch(setFilterClauseOperator(unit.id, id, value, resetClauseValue)),
  onFilterClauseValueChange: (id, value) => dispatch(setFilterClauseValue(unit.id, id, value)),
  setFilterVisibility: () => dispatch(setFilterVisibility(unit.id)),
  onRemoveFilter: () => dispatch(removeFilter(unit.id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventFilterContainer);
